import { css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { FontSizes, Spacing } from 'chatie-design-system';

import Badge, { BadgeProps } from '@components/common/Badge';
import { LinkItem } from '@components/common/ListItem';

import { StoryTheme } from '@constants';
import { IStoryAd, IStoryDetail } from '@model';
import { media } from '@styles/css';
import { useAnalytics } from '@utils/analytics';
import { useWebView } from '@utils/webview';

import { RSStoryCard } from './Story';

const containerCSS = css`
  display: grid;
  margin-top: ${Spacing.small}px;
  padding: 0px ${Spacing.medium}px;
  gap: ${Spacing.xsmall}px;

  ${media.tablet} {
    grid-template-columns: repeat(2, 1fr);
    padding: 0px ${Spacing.xlarge}px;
  }
  ${media.desktop} {
    padding: 0px ${Spacing.xxlarge}px;
  }
`;

type RSViewListPorps = {
  isShowAd: boolean;
  ad?: IStoryAd;
  badgePreset: Pick<BadgeProps, 'color' | 'backgroundColor' | 'border'>;
  curation: IStoryDetail[];
};

const RSViewList = ({
  isShowAd,
  ad,
  badgePreset,
  curation,
}: RSViewListPorps) => {
  const { firebase } = useAnalytics();
  const { t } = useTranslation();
  const { openPageOrMove } = useWebView();

  const handleClick = (url: string) => {
    openPageOrMove(url);
  };
  return (
    <div css={containerCSS}>
      {isShowAd && !!ad?.story && (
        <LinkItem
          newTab
          hideArrow
          className="br-bottom"
          onClick={() => {
            handleClick(`/stories/${ad.story.id}`);
            firebase.logEvent('story_ad_click', {
              storyId: ad.story?.id,
              storyAdId: ad?.id,
              where: 'curation',
            });
          }}
          left={
            <RSStoryCard
              {...ad.story}
              isLibrary={true}
              label={
                <Badge
                  text={t('홍보')}
                  {...badgePreset}
                  fontSize={FontSizes.xxsmall}
                />
              }
              tapCount={undefined}
            />
          }
        />
      )}
      {curation?.map((item, index) => {
        return (
          <LinkItem
              key={index.toString() + item.id + 'RSViewList'}
              onClick={() => {
                handleClick(
                  item.theme === StoryTheme.iknow
                    ? `/stories/${item.id}/licensed`
                    : `/stories/${item.id}`
                );
              }}
              newTab
              className="br-bottom"
              hideArrow
              left={
                <RSStoryCard {...item} tapCount={undefined} isLibrary={false} />
              }
            />
        );
      })}
    </div>
  );
};

export default RSViewList;
